<template>
    <b-card>
        <b-row>
            <b-col lg="12">
                <b-card header="Select Date Range"
                        header-text-variant="white"
                        header-bg-variant="info"
                >
                    <b-form inline @submit.prevent="loadItems()">
                        <date-picker
                                v-model="start_date"
                                placeholder="Start Date"
                        >
                        </date-picker> &nbsp;to&nbsp;
                        <date-picker
                                v-model="end_date"
                                placeholder="End Date"
                        >
                        </date-picker>
                        <b-form-select
                                id="caregiver_id"
                                name="caregiver_id"
                                v-model="caregiver_id"
                        >
                            <option value="">All Providers</option>
                            <option v-for="caregiver in caregivers" :value="caregiver.id" :key="caregiver.id">{{ caregiver.name }}</option>
                        </b-form-select>
                        <b-form-select
                                id="client_id"
                                name="client_id"
                                v-model="client_id"
                        >
                            <option value="">All Claimants</option>
                            <option v-for="client in clients" :value="client.id" :key="client.id">{{ client.name }}</option>
                        </b-form-select>
                        <b-form-select
                                id="method"
                                name="method"
                                v-model="filter_method"
                        >
                            <option value="">All Methods</option>
                            <option value="geolocation">Geolocation</option>
                            <option value="telephony">Telephony</option>
                        </b-form-select>
                        <b-form-select
                                id="method"
                                name="method"
                                v-model="filter_verified"
                        >
                            <option value="">All Statuses</option>
                            <option value="0">Unverified</option>
                            <option value="1">Verified</option>
                        </b-form-select>
                        <carrier-dropdown v-model="filter_carrier" emptyText="All Carrier"></carrier-dropdown>
                        &nbsp;
                        <b-button type="submit" variant="info" :disabled="loaded === 0">Generate Report</b-button>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="items.length">
            <b-col>
                <b-row>
                    <b-col lg="6">
                        <table class="table table-striped table-hover table-bordered">
                            <tbody>
                            <tr>
                                <th>Clock Ins</th>
                                <th>Verified</th>
                                <th>Unverified</th>
                                <th>Total</th>
                            </tr>
                            <tr>
                                <th>Geo</th>
                                <td>{{ check_in_summary.geo.verified }}</td>
                                <td>{{ check_in_summary.geo.unverified }}</td>
                                <td>{{ check_in_summary.geo.total }}</td>
                            </tr>
                            <tr>
                                <th>Telephony</th>
                                <td>{{ check_in_summary.telephony.verified }}</td>
                                <td>{{ check_in_summary.telephony.unverified }}</td>
                                <td>{{ check_in_summary.telephony.total }}</td>
                            </tr>
                            <tr>
                                <th>Total</th>
                                <td>{{ check_in_summary.total.verified }}</td>
                                <td>{{ check_in_summary.total.unverified }}</td>
                                <td>{{ check_in_summary.total.total }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </b-col>
                    <b-col lg="6">
                        <table class="table table-striped table-hover table-bordered">
                            <tbody>
                            <tr>
                                <th>Clock Outs</th>
                                <th>Verified</th>
                                <th>Unverified</th>
                                <th>Total</th>
                            </tr>
                            <tr>
                                <th>Geo</th>
                                <td>{{ check_out_summary.geo.verified }}</td>
                                <td>{{ check_out_summary.geo.unverified }}</td>
                                <td>{{ check_out_summary.geo.total }}</td>
                            </tr>
                            <tr>
                                <th>Telephony</th>
                                <td>{{ check_out_summary.telephony.verified }}</td>
                                <td>{{ check_out_summary.telephony.unverified }}</td>
                                <td>{{ check_out_summary.telephony.total }}</td>
                            </tr>
                            <tr>
                                <th>Total</th>
                                <td>{{ check_out_summary.total.verified }}</td>
                                <td>{{ check_out_summary.total.unverified }}</td>
                                <td>{{ check_out_summary.total.total }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-btn variant="success" :href="`${url}&export=1`" :disabled="loaded === 0">
                    <i class="fa fa-file-excel-o"></i> Export to Excel
                </b-btn>
            </b-col>
            <b-col lg="6" class="text-right mb-3">
                <b-form-input v-model="filter" placeholder="Type to Search" />
            </b-col>
        </b-row>
        <loading-card v-if="loaded == 0"></loading-card>
        <b-row v-if="loaded < 0">
            <b-col lg="12">
                <b-card class="text-center text-muted">
                    Select filters and press Generate Report
                </b-card>
            </b-col>
        </b-row>
        <div class="table-responsive" v-if="loaded > 0">
            <b-table bordered striped hover show-empty
                     :items="items"
                     :fields="fields"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     :filter="filter"
            >
                <template v-slot:cell(client_name)="row">
                    <a :href="'/business/clients/' + row.item.client_id">{{ row.item.client_name }}</a>
                </template>
                <template v-slot:cell(caregiver_name)="row">
                    <a :href="'/business/caregivers/' + row.item.caregiver_id">{{ row.item.caregiver_name }}</a>
                </template>
                <template v-slot:cell(checked_in_time)="row">
                    <utc-time :timezone="row.item.shift_timezone" :time="row.item.checked_in_time" format="h:mm A z"  />
                </template>
                <template v-slot:cell(checked_out_time)="row">
                    <utc-time :timezone="row.item.shift_timezone" :time="row.item.checked_out_time" format="h:mm A z" />
                </template>
                <template v-slot:cell(actions)="row">
                    <span v-if="row.item.id">
                        <b-btn size="sm" :href="'/business/shifts/' + row.item.id" variant="info" v-b-tooltip.hover title="Edit"><i class="fa fa-edit"></i></b-btn>
                        <b-btn size="sm" @click.stop="details(row.item)" v-b-tooltip.hover title="View"><i class="fa fa-eye"></i></b-btn>
                    </span>
                </template>
              <template v-slot:cell(checked_in_verified)="row">
                <span v-html="yesNo(row.item.checked_in_verified)" />
              </template>
              <template v-slot:cell(checked_out_verified)="row">
                <span v-html="yesNo(row.item.checked_out_verified)" />
              </template>
            </b-table>
        </div>
        
        <!-- Details modal -->
        <business-shift-details-modal :shift="selectedItem" v-model="detailsModal" />
    </b-card>
</template>

<script>
    import FormatsDates from "../../../mixins/FormatsDates";

    export default {
        mixins: [FormatsDates],

      props: {
        caregivers: {
          type: Array,
          default: () => [],
        },
        clients: {
          type: Array,
          default: () => [],
        },
        role: {
          type: String,
          default: '',
        },
      },

        data() {
            return {
                sortBy: 'shift_time',
                sortDesc: false,
                filter: null,
                loaded: -1,
                end_date: moment(new Date()).format('MM/DD/YYYY'),
                start_date: moment(new Date()).subtract(14, 'days').format('MM/DD/YYYY'),
                filter_method: "",
                filter_verified: "",
                filter_carrier: '',
                business_id: "",
                businesses: [],
                caregiver_id: "",
                client_id: "",
                items: [],
                detailsModal: false,
                selectedItem: {
                    client: {}
                },
                check_in_summary: { geo: {}, telephony: {}, total: {} },
                check_out_summary: { geo: {}, telephony: {}, total: {} },
                fields: [
                    {
                        key: 'date',
                        formatter: this.dayFormat,
                        sortable: true,
                    },
                    {
                        key: 'client_name',
                        label: 'Claimant',
                        sortable: true,
                    },
                    { key: 'carrier', sortable: true, },
                    {
                        key: 'caregiver_name',
                        label: 'Provider',
                        sortable: true,
                    },
                    {
                        key: 'checked_in_time',
                        label: 'Clock In',
                        formatter: (val) => this.formatTimeFromUTC(val),
                        sortable: true,
                    },
                    {
                        key: 'checked_in_method',
                        label: 'Method',
                        sortable: true,
                    },
                    {
                        key: 'checked_in_verified',
                        label: 'EVV',
                        sortable: true,
                    },
                    {
                        key: 'evv_message',
                        label: 'EVV Message',
                        sortable: true,
                    },
                    {
                        key: 'checked_in_distance',
                        label: 'Distance (m)',
                        formatter: this.distanceFormat,
                        sortable: true,
                    },
                    {
                        key: 'checked_out_time',
                        label: 'Clock Out',
                        formatter: (val) => this.formatTimeFromUTC(val),
                        sortable: true,
                    },
                    {
                        key: 'checked_out_method',
                        label: 'Method',
                        sortable: true,
                    },
                    {
                        key: 'checked_out_verified',
                        label: 'EVV',
                        sortable: true,
                    },
                    {
                        key: 'checked_out_distance',
                        label: 'Distance (m)',
                        formatter: this.distanceFormat,
                        sortable: true,
                    },
                    {
                        key: 'os',
                        label: 'OS',
                        sortable: true,
                    },
                    {
                        key: 'browser',
                        sortable: true,
                    },
                    { key: 'actions', sortable: false, class: 'hidden-print' }
                ]
            }
        },

        mounted() {
        },

        computed: {
            url() {
                return '/business/reports/evv?json=1&start_date=' + this.start_date + '&end_date=' + this.end_date +
                    '&business_id=' + this.business_id + '&caregiver_id=' + this.caregiver_id +  '&client_id=' + this.client_id +
                    '&method=' + this.filter_method + '&verified=' + this.filter_verified + `&carrier=${this.filter_carrier}`;
            },
        },

        methods: {
            details(item) {
                let component = this;
                axios.get('/business/shifts/' + item.id)
                    .then(function(response) {
                        let shift = response.data;
                        shift.checked_in_time = moment.utc(shift.checked_in_time).local().format('L LT');
                        shift.checked_out_time = shift.checked_out_time ? moment.utc(shift.checked_out_time).local().format('L LT') : 'Pending';
                        component.selectedItem = shift;
                        component.detailsModal = true;
                        console.log(component.selectedItem);
                    })
                    .catch(function(error) {
                        alert('Error loading shift details');
                    });
            },

            loadItems() {
                this.loaded = 0;
                axios.get(this.url)
                    .then(response => {
                        this.check_in_summary = response.data.check_in_summary;
                        this.check_out_summary = response.data.check_out_summary;
                        this.items = response.data.data.map(function (item) {
                            item.date = item.checked_in_time.split(' ')[0];
                            item.business_name = item.business.name;
                            item.caregiver_name = item.caregiver.nameLastFirst;
                            item.client_name = item.client.nameLastFirst;
                            item.checked_in_method = item.checked_in_number ? 'Telephony' : 'Geolocation';
                            item.checked_out_method = item.checked_out_number ? 'Telephony' : 'Geolocation';
                            item.os = (item.user_agent.os) ? item.user_agent.os.family + (item.user_agent.os.major ? ' ' + item.user_agent.os.major : '') : '';
                            item.browser = (item.user_agent.ua) ? item.user_agent.ua.family + (item.user_agent.ua.major ? ' ' + item.user_agent.ua.major : '') : '';

                            // Replace null distances with blocked for geolocation
                            if (item.checked_in_method === 'Geolocation' && item.checked_in_distance === null) {
                                item.checked_in_distance = 'Blocked';
                                if (item.checked_in_latitude) {
                                    item.checked_in_distance = 'Unknown'; // Usually an address issue
                                }
                            }
                            if (item.checked_out_method === 'Geolocation' && item.checked_out_distance === null) {
                                item.checked_out_distance = 'Blocked';
                                if (item.checked_out_latitude) {
                                    item.checked_out_distance = 'Unknown'; // Usually an address issue
                                }
                            }

                            return item;
                        });
                        this.loaded = 1;
                    })
                    .catch(error => this.loaded = -1);
            },

            dayFormat(date) {
                return moment(date).local().format('ddd MMM D');
            },

            yesNo(val) {
                return val ? '<i class="fa fa-check-square-o"></i>' : '<i class="fa fa-times-rectangle-o"></i>';
            },

            distanceFormat(val) {
                return (val === 0) ? '<1' : val;
            }
        }
    }
</script>

<style>
    table:not(.form-check) {
        font-size: 14px;
    }
    .fa-check-square-o { color: green; }
    .fa-times-rectangle-o { color: darkred; }
</style>
